<!--
 * @Description: 名单库添加
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <div>
    <el-alert
      title="只支持同一园区个体做同一项目"
      type="error"
      :closable="false"
    ></el-alert>
    <table-render
      ref="nameListTableRender"
      :config="config"
      :propData="propData"
      :rowClassName="
        ({ row, rowIndex }) =>
          getUnqualifiedRowConfig({
            row: row,
            rowIndex: rowIndex,
            isNotUnqualified: isNotUnqualified(row)
          })
      "
      rowKey="userId"
      height="55vh"
    />
    <div class="footer">
      <p>
        <span class="select-all" @click="chooseAll">全选</span>
      </p>
      <div class="footer-button-group">
        <el-button type="primary" @click="confirm" :loading="btLoading">
          确认添加
        </el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';
import { projectPersonnelManagement } from '@/api/ajax';
import { btLoading } from '@/Mixin/btLoading';
import { deepClone } from '@/tools';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';
export default {
  mixins: [btLoading],
  name: 'NameList',
  inject: ['_parent'], // src\page\project-personnel-inside\list\index.vue
  data() {
    return {
      getUnqualifiedRowConfig,
      config: [],
      propData: {
        query: {
          projectId: this.$route.query.id,
          taskDt: this.$route.query.taskDt
        }
      },
      selection: [],
      personLabels: {} // 解决切换页面后，表格中输入的 本次导入标签 被重置问题
    };
  },
  components: { tableRender },
  computed: {
    homeProject() {
      return this.$store.state.homeProject;
    },
    // 0为人 1为个体
    type() {
      return this.homeProject.projectStructureType === 2 ? 1 : 0;
    }
  },
  watch: {},
  methods: {
    isNotUnqualified(row) {
      return !(
        ('superviseStatus' in row && row.superviseStatus === 3) ||
        row.zbBlackStatus === 2
      );
    },
    async chooseAll() {
      await this.$refs.nameListTableRender.selectAllByRowKey({
        listAjax: projectPersonnelManagement.panelLibraryAddsAListCheckAll
      });
    },
    cancel() {
      this.$xrkDialog.remove();
    },
    selectedDataHandler(selection) {
      let userInfoList = [];
      selection.map(params => {
        userInfoList.push({
          userId: params.userId,
          userTag: this.personLabels[params.userId]
        });
      });
      let data = {
        projectId: this.$route.query.id,
        taskDt: this.$route.query.taskDt,
        userInfoList,
        btnLoading: true
      };
      return data;
    },
    emptyCheck() {
      if (!this.selection.length) {
        this.$message.error('请至少选择一个人员');
        return false;
      }
      return true;
    },
    confirm() {
      if (!this.emptyCheck()) {
        return;
      }
      this.SET_BTLOADING(true);
      // 该接口单独处理的传参方式
      projectPersonnelManagement
        .savePanelLibraryAddsAList(this.selectedDataHandler(this.selection))
        .then(() => {
          // 刷新当前列表
          this.$refs.nameListTableRender.saveSuccess();
          this.$refs.nameListTableRender.clearTableSelection();
          this.SET_BTLOADING(false);
          this.$xrkDialog.remove();
          // 刷新最外层列表
          this._parent.$children[0].saveSuccess();
        });
    }
  },
  created() {
    const part = deepClone(config[this.type]);
    // 设置园区默认值
    part[0].childMenu[0].defaultQuery['select_userEnterpriseParkCode'] = {
      userEnterpriseParkName: this.homeProject.userEnterpriseParkName,
      userEnterpriseParkCode: this.homeProject.userEnterpriseParkId
    };
    const removeFields = [];
    const removeSearchs = [];
    if (!this.$checkNeedUserTag(this.$store.state.homeProject)) {
      // 特定情况需要删除人员标签
      removeFields.push(...['其他项目标签', '本次导入标签']);
      removeSearchs.push(...['其他项目标签']);
    }
    const dealConfig = (arr, rmArr) => {
      rmArr.length > 0 &&
        rmArr.forEach(rmLabel => {
          arr.forEach((obj, index) => {
            if (rmLabel === obj.label) {
              arr.splice(index, 1);
            }
          });
        });
    };
    dealConfig(part[0].childMenu[0].fields, removeFields);
    dealConfig(part[0].childMenu[0].search, removeSearchs);

    this.config = part;

    // // 从项目中 获取 关于园区的信息
    //   const projectInfo = this.$store.state.homeProject;
    // function createParkOption(info) {
    //   let { userEnterpriseParkName: name } = info;
    //   let { userEnterpriseParkId: key } = info;
    //   return {
    //     name,
    //     key
    //   };
    // }
    //
    // // 生成 园区选项
    // const parkSelectOption = createParkOption(projectInfo);
    // console.log('parkSelectOption');
    // console.log(parkSelectOption);
    // // 找到园区组件
    //
    // // 设置园区选项
    // const searchConfig = config[0]['childMenu'][0]['search'];
    // const yuanquIndex = searchConfig.findIndex(i => i.id === 'yuanqu');
    // // searchConfig[yuanquIndex].options = parkSelectOption;
    // searchConfig[yuanquIndex].options = {
    //   name: 'name',
    //   key: 'key'
    // };
    //
    // const children = this.$refs.nameListTableRender.$children;
    // console.log('children');
    //
    // // 找到 搜索组件
    // let searchComponent = null;
    // for (let i = 0; i < children.length; i++) {
    //   console.log(children[i].$options.name);
    //   if (children[i].$options.name === 'tableRenderSearch') {
    //     searchComponent = children[i];
    //   }
    // }
    //
    // // 找到 园区组件
    // if (searchComponent) {
    //   let children = searchComponent.$children;
    //   for (let i = 0; i < children.length; i++) {}
    // }

    // this.config = config;
    this.$nextTick(() => {
      this.selection = this.$refs.nameListTableRender.$refs.table.selection;
    });
  },
  mounted() {
    // setTimeout(() => {
    //   const table = this.$refs.nameListTableRender;
    //
    //   // 从项目中 获取 关于园区的信息
    //   const projectInfo = this.$store.state.homeProject;
    //   function createParkOption(info) {
    //     let { userEnterpriseParkName: name } = info;
    //     let { userEnterpriseParkId: key } = info;
    //     console.log(info);
    //     return {
    //       name,
    //       key
    //     };
    //   }
    //
    //   // 生成 园区选项
    //   const parkSelectOption = createParkOption(projectInfo);
    //   console.log('parkSelectOption');
    //   console.log(parkSelectOption);
    //
    //   const options = [parkSelectOption];
    //
    //   // 找到 园区组件 设置选项和值
    //   function rec(ele) {
    //     if (ele.placeholder === '请选择园区') {
    //       setInterval(() => {
    //         ele.$slots.default = options.map(item => {
    //           return ele._c('el-option', {
    //             props: {
    //               value: item.name,
    //               label: item.name,
    //               key: item.key
    //             }
    //           });
    //         });
    //         ele.value = options[0].value;
    //       }, 60);
    //     }
    //     if (ele.$children && ele.$children.length) {
    //       ele.$children.forEach(rec);
    //     }
    //   }
    //   table.$children.forEach(rec);
    // });
  }
};
</script>

<style scoped lang="scss">
.select-all {
  cursor: pointer;
}
.footer {
  padding: 0 25px;
}
.footer-button-group {
  display: flex;
  justify-content: flex-end;
}
</style>
